import {
    
     CREATEHOSPITALEAPPOINMENTSHIFT,
     CREATEHOSPITALEAPPOINMENTSLOT,
     DELETEHOSPITALEAPPOINMENTSHIFT, 
     DELETEHOSPITALEAPPOINMENTSLOT, 
     GETHOSPITALEAPPOINMENTSHIFT, 
     GETHOSPITALEAPPOINMENTSLOT, 
     GETHOSPITALEAPPOINMENTSLOTBYDOCTOR, 
     UPDATEHOSPITALAPPOINMENTSHIFT, 
     UPDATEHOSPITALAPPOINMENTSLOT

    } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEHOSPITALEAPPOINMENTSHIFT:
            return {
                ...state,
                shiftSaveStatus: action.payload.success,
            }
        case GETHOSPITALEAPPOINMENTSHIFT:
                return {
                        ...state,
                        shiftList: action.payload.data,
                        }
        case UPDATEHOSPITALAPPOINMENTSHIFT:
                return {
                        ...state,
                        shiftUpdateStatus: action.payload.success,
                        }   

        case DELETEHOSPITALEAPPOINMENTSHIFT:
                 return {
                     ...state,
                     shiftDeleteStatus: action.payload.success,
                        } 
         case CREATEHOSPITALEAPPOINMENTSLOT:
                   return {
                            ...state,
                            slotSaveStatus: action.payload.success,
                            }
        case GETHOSPITALEAPPOINMENTSLOT:
                    return {
                            ...state,
                            slotList: action.payload.data,
                            }
        case GETHOSPITALEAPPOINMENTSLOTBYDOCTOR:
                    return {
                            ...state,
                            slotbydoctorList: action.payload.data,
                            }
        case UPDATEHOSPITALAPPOINMENTSLOT:
                    return {
                            ...state,
                            slotUpdateStatus: action.payload.success,
                            }   
                
        case DELETEHOSPITALEAPPOINMENTSLOT:
                    return {
                            ...state,
                            slotDeleteStatus: action.payload.success,
                            } 

                        default:
                            return state
                             }
                         }